import script from "./EditTalkRoomModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditTalkRoomModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditTalkRoomModal.vue?vue&type=style&index=0&id=2487a9f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2487a9f6"]])

export default __exports__